/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { isSameWeek } from 'date-fns';
import useFlowersDeliveryCalendar from '../../../../../hooks/queries/useFlowersDeliveryCalendar';
import useFoodDeliveryCalendar from '../../../../../hooks/queries/useFoodDeliveryCalendar';

import { calendarMapPresentation, getProductBaseCodeSku } from '../../Helpers/Sku-helper';
import { getFormattedDate } from '../../Helpers/Helper';

export const MonthsFullName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const MonthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const addZeroOnDate = (n) => {
    /* eslint-disable no-param-reassign */
    n = n.toString();
    if (n.length < 2) {
        return `0${n}`;
    }
    return n;
};

export const getCurrentDate = () => {
    const nowDate = new Date();
    nowDate.setHours(0, 0, 0, 0);
    return nowDate;
};

export const formatDateDDMMYYToYYYYMMDD = (dateString) => {
    if (dateString && dateString.indexOf('-') > 0) {
        const splitDate = dateString.split('-');

        const dateDay = addZeroOnDate(splitDate[0]);
        const dateMonth = addZeroOnDate(MonthShort.indexOf(splitDate[1]) + 1);
        const dateYear = `20${splitDate[2]}`;

        return `${dateYear}-${dateMonth}-${dateDay}`;
    }
    return dateString;
};

export const getListHolidayDates = (calendarDates) => {
    let temp = '';
    const holidayDays = {};
    calendarDates.forEach((dateDetails) => {
        const delHolidayCode = dateDetails.holidayCode;
        if (temp !== delHolidayCode) {
            temp = delHolidayCode;
            holidayDays[delHolidayCode] = [];
        }
        holidayDays[delHolidayCode].push(dateDetails);
    });
    return holidayDays;
};

export const convertDateStringToObj = (dateStr) => {
    const tempDate = dateStr.split('-'); // YY-mm-dd
    const date = tempDate[2];
    const month = (parseInt(tempDate[1], 10) - 1);
    const year = tempDate[0];
    const dateObj = new Date(year, month, date);
    return dateObj;
};

export const convertDateObjToStrDate = (dateObj) => {
    const date = addZeroOnDate(dateObj.getDate());
    const month = addZeroOnDate((parseInt(dateObj.getMonth(), 10) + 1));
    const year = dateObj.getFullYear();
    return `${year}-${month}-${date}`;
};

export const getDateStrBtn = (startDate, endDate) => {
    const loopDate = new Date(startDate);
    endDate = endDate.setDate(endDate.getDate() + 1);
    const loopEndDate = new Date(endDate);
    const dateRange = [];
    while (loopEndDate.toDateString() !== loopDate.toDateString()) {
        dateRange.push(new Date(loopDate));
        loopDate.setDate(loopDate.getDate() + 1);
    }
    return dateRange;
};

export const getListDeliveryDates = (calendarDates) => {
    let temp = '';
    const deliveryMonthsToShow = {};
    calendarDates.forEach((dateDetails) => {
        const delDate = dateDetails.deliveryDate;
        if (temp !== delDate) {
            temp = delDate;
            deliveryMonthsToShow[delDate] = [];
        }
        deliveryMonthsToShow[delDate].push(dateDetails);
    });

    return deliveryMonthsToShow;
};

export const getEnterpriseCalendarData = ({
    cartId,
    customerType,
    leadTimeEnterpriseCalendarEnabled,
    isNewDeliveryCalendaV2CheckoutEnabled,
    orderItem,
    recipientItem,
    startDate,
}) => {
    const isStandaloneCard = ['GREETINGCARD-ITEM'].includes(orderItem.itemInfo?.lineItemType);
    const calendarPresentationFamily = calendarMapPresentation[orderItem?.product?.brandCode || '1001'] || 'flower';

    if (
        (calendarPresentationFamily === 'flower' && orderItem.deliveryInfo?.zipCode)
        || (isNewDeliveryCalendaV2CheckoutEnabled && orderItem.displayDeliveryCalendar)
        || isStandaloneCard
    ) {
        const startDeliveryDate = getFormattedDate(startDate, 'd-MMM-yy');
        const productCode = getProductBaseCodeSku(orderItem?.product?.productCode);

        return useFlowersDeliveryCalendar({
            brandCode: orderItem.product.brandCode,
            customerType,
            productCode,
            leadTimeEnterpriseCalendarEnabled,
            locationType: orderItem.deliveryInfo?.locationType || 'Residence',
            zipCode: orderItem.deliveryInfo?.zipCode,
            startDate: startDeliveryDate,
        });
    }

    return useFoodDeliveryCalendar({
        cartId,
        cartItemId: orderItem.cartItemId,
        leadTimeEnterpriseCalendarEnabled,
        startDate,
    });
};

export const getHolidayDeliveryDate = (holidayCode, calendarDates) => {
    const [holidayDateDetails] = calendarDates.filter((dateObj) => {
        // Handle Array Type for holidaycode - ["CH", "NW"]
        // And String Type for holidaycode - "CH"
        if (dateObj?.holidayCode && Array.isArray(dateObj.holidayCode) && dateObj.holidayCode.includes(holidayCode)) {
            return dateObj;
        } if (dateObj?.holidayCode === holidayCode) {
            return dateObj;
        }
        return '';
    });
    if (holidayDateDetails && holidayDateDetails.deliveryDate) {
        return holidayDateDetails.deliveryDate;
    }
    return '';
};

export const getBannerDataFromCMS = (selectedDate, cmsData, isCalendarHolidayBannerEnabled) => {
    let isBannerEnabled = false;
    let bannerIcon = null;
    let flexBannerHoliday = {};

    if (cmsData?.entries?.[0]) {
        bannerIcon = cmsData.entries[0].flex_banner?.[0]?.icon?.url || null;
        flexBannerHoliday = cmsData.entries[0].flex_holiday_banner || {};
        // This conditions is exclusive for testing DELETE AFTER FINISH ++++++++++++++++++++++++++++++++++++++++++
        // if (flexBannerHoliday.holiday_date_range) {
        //     flexBannerHoliday = {
        //         ...flexBannerHoliday,
        //         holiday_date_range: {
        //             start_date: '2025-11-24',
        //             end_date: '2025-11-27',
        //         },
        //     };
        // }
        // end
        const flexBannerHolidayDateRangeCms = flexBannerHoliday.holiday_date_range || {};

        if (
            isCalendarHolidayBannerEnabled
            && flexBannerHolidayDateRangeCms.start_date
            && flexBannerHolidayDateRangeCms.end_date
            && selectedDate
        ) {
            const holidayBannerStartDate = convertDateStringToObj(flexBannerHolidayDateRangeCms.start_date);
            const holidayBannerEndDate = convertDateStringToObj(flexBannerHolidayDateRangeCms.end_date);

            let currentDate = '';
            if (typeof selectedDate === 'string') {
                currentDate = convertDateStringToObj(selectedDate);
            } else {
                currentDate = selectedDate;
            }

            if (
                isSameWeek(holidayBannerStartDate, currentDate)
                || isSameWeek(holidayBannerEndDate, currentDate)
            ) {
                isBannerEnabled = true;
            }
        }
    }
    return {
        isBannerEnabled,
        bannerIcon,
        flexBannerHoliday,
    };
};

export default {};
